import { CreateOrganization } from "@clerk/clerk-react";
import { createFileRoute, useRouter } from "@tanstack/react-router";

export const Route = createFileRoute("/onboarding/create-org")({
  component: RouteComponent,
});

function RouteComponent() {
  const router = useRouter();

  return (
    <CreateOrganization
      afterCreateOrganizationUrl={router.routesByPath["/onboarding"].fullPath}
      hideSlug
      appearance={{
        elements: {
          rootBox: "!shadow-none !w-full",
          cardBox: "!shadow-none !w-full",
          card: "!px-6 !py-6",
          headerTitle: "!text-2xl",
          footer: "!h-0",
          formButtonPrimary: "!shadow-none !bg-primary h-9 !text-sm",
          input: "!text-base",
          form: "[&>div]:has-[.cl-formButtonPrimary]:!flex-row",
        },
      }}
      skipInvitationScreen={true}
    />
  );
}
